import Logger from './logger';
import {
  EVENT_PAGE,
  EVENT_IDENTIFY,
  EVENT_ACCOUNTCREATED,
  EVENT_DOWNLOADED,
  EVENT_ERROR,
  EVENT_SEARCHED,
  EVENT_CHECKOUTSTARTED,
  EVENT_ORDERCOMPLETED,
  EVENT_EXPERIMENTVIEWED,
  EVENT_PRODUCTLISTVIEWED,
  EVENT_SIGNEDIN,
  EVENT_INVITESENT,
  EVENT_PRODUCTSEARCHED,
  EVENT_SEMANTICCHECKOUTSTARTED,
  EVENT_SEMANTICORDERCOMPLETED,
  EVENT_PRODUCTADDEDTOWISHLIST,
  EVENT_SIGNEDUP,
  EVENT_CARTVIEWED,
  EVENT_PAYMENTINFOENTERED,
  EVENT_PRODUCTADDED,
  EVENT_PRODUCTREMOVED
} from './util';

const eventPage = (provider, data) => {
  const { pageType } = data.page;
  provider.logger.info(`EVENT pageview: ${pageType}`);
  provider.analytics.page(pageType, data);
};

const eventIdentify = (provider, data, opt) => {
  let options;
  provider.logger.info('EVENT identify');
  if (opt) {
    const externalIds = [];
    Object.keys(opt).forEach(key => {
      if (key === 'email' || key === 'visitor_id') {
        externalIds.push({
          id: opt[key],
          type: key,
          collection: 'users',
          encoding: 'none'
        });
      }
    });

    if (externalIds.length > 0) {
      options = {
        externalIds
      };
    }
  }

  provider.analytics.identify(data.userId, data.traits, options);
};

const eventAccountCreated = (provider, data) => {
  provider.logger.info('EVENT account created');
  provider.analytics.track('accountCreationSuccess', data);
  provider.analytics.track('accountCreationSuccess-iframe', data);
};

const eventDownloaded = (provider, data) => {
  provider.logger.info('EVENT downloaded');
  provider.analytics.track('download-success', data);
};

const eventError = (provider, data) => {
  provider.logger.info('EVENT error');
  provider.analytics.track('Error', data);
};

const eventSearched = (provider, data) => {
  provider.logger.info('EVENT searched');
  provider.analytics.track('searchResults', data);
};

const eventCheckoutStarted = (provider, data) => {
  provider.logger.info('EVENT checkout started');
  provider.analytics.track('checkoutStart', data);
};

const eventOrderCompleted = (provider, data) => {
  provider.logger.info('EVENT purchaseSuccess');
  provider.analytics.track('purchaseSuccess', data);
};

const eventExperimentVieved = (provider, data) => {
  provider.logger.info('EVENT Experiment Viewed');
  provider.analytics.track('Experiment Viewed', data);
};

const eventProductListViewed = (provider, data) => {
  provider.logger.info('EVENT Product List Viewed');
  provider.analytics.track('Product List Viewed', data);
};

const eventSignedIn = (provider, data) => {
  provider.logger.info('EVENT Signed In');
  provider.analytics.track('Signed In', data);
};

const eventInviteSent = (provider, data) => {
  provider.logger.info('EVENT Invite Sent');
  provider.analytics.track('Invite Sent', data);
};

const eventProductSearched = (provider, data) => {
  provider.logger.info('EVENT Products Searched');
  provider.analytics.track('Products Searched', data);
};

const eventSemanticCheckoutStarted = (provider, data) => {
  provider.logger.info('EVENT Checkout Started');
  provider.analytics.track('Checkout Started', data);
};

const eventProductAddedToWishlist = (provider, data) => {
  provider.logger.info('EVENT Product Added To Wishlist');
  provider.analytics.track('Product Added To Wishlist', data);
};

const eventSignedUp = (provider, data) => {
  provider.logger.info('EVENT Signed Up');
  provider.analytics.track('Signed Up', data);
  provider.analytics.track('accountCreationSuccess-iframe', data);
};

const eventCartViewed = (provider, data) => {
  provider.logger.info('EVENT Cart Viewed');
  provider.analytics.track('Cart Viewed', data);
};

const eventSemanticOrderCompleted = (provider, data) => {
  provider.logger.info('EVENT Order Completed');
  provider.analytics.track('Order Completed', data);
};

const eventPaymentInfoEntered = (provider, data) => {
  provider.logger.info('EVENT Payment Info Entered');
  provider.analytics.track('Payment Info Entered', data);
};

const eventProductAdded = (provider, data) => {
  provider.logger.info('EVENT Product Added');
  provider.analytics.track('Product Added', data);
};

const eventProductRemoved = (provider, data) => {
  provider.logger.info('EVENT Product Removed');
  provider.analytics.track('Product Removed', data);
};

const otherwise = (provider, payload, data) => {
  provider.logger.info(`EVENT track: ${payload.name}`);
  provider.analytics.track(payload.name, data);
};

export default class SegmentProvider {
  constructor() {
    this.providerLoaded = false;
    this.tagCollectorLoaded = false;
    this.tagCollectorUrl = null;
    this.analytics = null;
    this.logger = Logger.getLogger();
  }

  /* eslint-disable */
  load(sourceId) {
    const myClass = this;
    return new Promise((resolve, reject) => {
      var analytics = (window.analytics = window.analytics || []);

      if (!analytics.initialize && analytics !== myClass) {
        if (analytics.invoked) {
          const err = new Error('Segment snippet included twice.');
          myClass.logger.error(err.message);
          reject(err);
        } else {
          analytics.invoked = !0;

          analytics.load = function(t, e) {
            var n = document.createElement('script');
            n.type = 'text/javascript';
            n.async = true;
            n.src =
              'https://cdn.segment.com/analytics.js/v1/' +
              t +
              '/analytics.min.js';
            n.onload = function() {
              myClass.logger.debug('segment has been loaded');
              myClass.providerLoaded = true;
              myClass.analytics = window.analytics;
              resolve();
            };
            var a = document.getElementsByTagName('script')[0];
            a.parentNode.insertBefore(n, a);
            analytics._loadOptions = e;
          };

          analytics.SNIPPET_VERSION = '4.1.0';
          analytics.load(sourceId);
        }
      } else {
        reject(new Error('Segment already initialized'));
      }
    });
  }
  /* eslint-enable */

  setupTagCollector(tagCollectorUrl) {
    if (this.tagCollectorLoaded) {
      this.logger.warn('tag collector integration has already been setup.');
      return;
    }

    this.tagCollectorUrl = tagCollectorUrl;

    if (!this.providerLoaded) {
      this.tagCollectorUrl = tagCollectorUrl;
      return;
    }

    const sendRequest = payload => {
      const req = new XMLHttpRequest();
      req.open('POST', this.tagCollectorUrl, true);
      req.withCredentials = true;
      req.send(payload);
    };

    // TODO: come back and fix this mehtod so that we are returning a new
    //  result to clean up lint issues
    const normalizeMsg = (msg, type) => {
      if (!msg.timestamp) msg.timestamp = new Date(); // eslint-disable-line no-param-reassign
      if (!msg.type) msg.type = type; // eslint-disable-line no-param-reassign
      return msg;
    };

    const tagCollectorPageHandler = (category, name, properties, options) => {
      const msg = this.analytics.normalize({
        properties,
        category,
        options,
        name
      });
      normalizeMsg(msg, 'page');
      sendRequest(window.JSON.stringify(msg));
    };

    const tagCollectorTrackHandler = (event, properties, options) => {
      const msg = this.analytics.normalize({
        event,
        properties,
        options
      });
      normalizeMsg(msg, 'track');
      sendRequest(window.JSON.stringify(msg));
    };

    const tagCollectorIdentifyHandler = (id, traits, options) => {
      const msg = this.analytics.normalize({
        id,
        traits,
        options
      });
      normalizeMsg(msg, 'identify');
      sendRequest(window.JSON.stringify(msg));
    };

    this.analytics.on('page', tagCollectorPageHandler);
    this.analytics.on('track', tagCollectorTrackHandler);
    this.analytics.on('identify', tagCollectorIdentifyHandler);
    this.tagCollectorLoaded = true;
  }

  handleMessage(name, payload) {
    const { data } = payload || {};
    const opt = data.opt || {};
    const events = {
      [EVENT_PAGE]: eventPage,
      [EVENT_IDENTIFY]: eventIdentify,
      [EVENT_ACCOUNTCREATED]: eventAccountCreated,
      [EVENT_DOWNLOADED]: eventDownloaded,
      [EVENT_ERROR]: eventError,
      [EVENT_SEARCHED]: eventSearched,
      [EVENT_CHECKOUTSTARTED]: eventCheckoutStarted,
      [EVENT_ORDERCOMPLETED]: eventOrderCompleted,
      [EVENT_EXPERIMENTVIEWED]: eventExperimentVieved,
      [EVENT_PRODUCTLISTVIEWED]: eventProductListViewed,
      [EVENT_SIGNEDIN]: eventSignedIn,
      [EVENT_INVITESENT]: eventInviteSent,
      [EVENT_PRODUCTSEARCHED]: eventProductSearched,
      [EVENT_SEMANTICCHECKOUTSTARTED]: eventSemanticCheckoutStarted,
      [EVENT_SEMANTICORDERCOMPLETED]: eventSemanticOrderCompleted,
      [EVENT_PRODUCTADDEDTOWISHLIST]: eventProductAddedToWishlist,
      [EVENT_SIGNEDUP]: eventSignedUp,
      [EVENT_CARTVIEWED]: eventCartViewed,
      [EVENT_PAYMENTINFOENTERED]: eventPaymentInfoEntered,
      [EVENT_PRODUCTADDED]: eventProductAdded,
      [EVENT_PRODUCTREMOVED]: eventProductRemoved
    };
    return typeof events[name] === 'function'
      ? events[name](this, data, opt)
      : otherwise(this, payload, data);
  }
}
